/**
 * SMWeb Utils Module
 * @module @sm/utils
 */

/**
 * Instance of dompurify
 *
 * @function sanitizeString
 */
const sanitizeString = require('./string/sanitizeString');
const isValidEmail = require('./string/isValidEmail');
const createURL = require('./url/createURL');
const deepFreeze = require('./object/deepFreeze');
const S3Uploader = require('./S3Uploader/S3Uploader');
const { getClientEnvironmentDetails } = require('./environment');

const {
  getGraphQLClientForBrowser,
  getGraphQLClientForServer,
  getGraphQLFragmentMatcher
} = require('./graphql');

module.exports = {
  createURL,
  deepFreeze,
  isValidEmail,
  getClientEnvironmentDetails,
  sanitizeString,
  getGraphQLClientForBrowser,
  getGraphQLClientForServer,
  getGraphQLFragmentMatcher,
  S3Uploader
};
